import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import {
  CreateFolderResponse,
  Permission
} from '@utils/types/folders/folder.ts';
import { POST_URL } from '@utils/api/endpoints.ts';

export const useCreateFolder = () => {
  const queryClient = useQueryClient();

  return useMutation<
    CreateFolderResponse,
    AxiosError<BaseError>,
    {
      name: string;
      permissions: Permission[];
      parent_id: number | null;
    }
  >(
    async folderData => {
      const response = await Axios.post<CreateFolderResponse>(
        POST_URL().createFolder,
        folderData
      );
      return response.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('folders');
      },
      useErrorBoundary: false
    }
  );
};
